/**
 * Main actions
 */
export const SWITCH_CATEGORY = 'SWITCH_CATEGORY'
